import { useState } from "react";

// ** Regex - Sprawdzenie poprawności nazwy profilu
const REGEX_LOGIN_CHECK = /^[a-zA-Z0-9]+$/;

export const isValid = (value) => {
	if (value === "") {
		return true;
	}

	if (REGEX_LOGIN_CHECK.exec(value)) {
		return true;
	}
	return false;
};

export default ({ initial = "" }) => {
	const [selected, setSelected] = useState(initial);

	const isSelected = selected?.length > 0;

	const setSelectedValue = (value) => {
		setSelected(value);
	};

	const clear = () => {
		setSelected("");
		return true;
	};

	return {
		selected,
		setSelected: setSelectedValue,
		isSelected,
		clear,
		isValid,
	};
};
